import { render, staticRenderFns } from "./MerchantImpower.vue?vue&type=template&id=a16e0646&"
import script from "./MerchantImpower.vue?vue&type=script&lang=js&"
export * from "./MerchantImpower.vue?vue&type=script&lang=js&"
import style0 from "./MerchantImpower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports